// Команды CardForm.
var c_CardFormCmd_AddDetailItem = 1;
var c_CardFormCmd_DeleteDetailItem = 2;

(function () {
  var startMonitoringTime = $.now();

  window.CardForm = function () {
    if (typeof console !== 'undefined' && typeof console.warn !== 'undefined') {
      log.warn('DEFAULT','Cardform is marked as deprecated since WebAccess 5.0.0.7100 version, use WebAccess.current.form instead');
    }
    WA.include('/js/cardform.js');
    window.CardForm = CardForm;
    if (typeof (window.formData) !== 'undefined') CardForm().init(formData);

    var someWait = $.Deferred();
    setTimeout(function () { someWait.resolve(); }, 200);
    $.when(WA.FormInit, WA.FormControlsInit, someWait).done(function () {
      $('html').trigger('CardFormInit');
    });
    return window.CardForm();
  };

  var CardFormInitMonitor = function () {
    // Максимум мониторим 3 сек.
    if ($.now() - startMonitoringTime > 3000) return;
    // Проверяем навесился ли кто-то на CardFormInit, если да, то инициализируем CardForm.
    if (typeof (jQuery.event.global['CardFormInit']) !== 'undefined' && typeof (window.formData) !== 'undefined') {
      window.CardForm();
    } else {
      setTimeout(CardFormInitMonitor, 100);
    }
  };
  CardFormInitMonitor();

})();
